import { AllProductTypes } from '@repo/payments-core';

import { getFieldFromFactory } from '../../../factories/FieldFactory';
import {
  AllFormFieldModelsType,
  FormFieldsType,
  NextStepDetailsType,
  StepConfigType,
  StepInfoType,
  StepTypesEnumType
} from '../../../types/FieldModelTypes';

import { UserProfileModel } from '../UserProfileModel';

class StepConfig {
  stepId: string;
  stepType: StepTypesEnumType;
  nextStepDetails: NextStepDetailsType | undefined;
  previousStepDetails: NextStepDetailsType | undefined;
  stepInfo: StepInfoType | undefined;
  stepFields: AllFormFieldModelsType[];
  constructor(
    stepConfig: StepConfigType,
    userProfileDetails: UserProfileModel | null,
    product?: AllProductTypes | null
  ) {
    const {
      step_id,
      step_type,
      next_step_details,
      previous_step_details,
      step_info,
      fields_data
    } = stepConfig;

    this.stepId = step_id;
    this.stepType = step_type;
    this.nextStepDetails = next_step_details;
    this.previousStepDetails = previous_step_details;
    this.stepInfo = step_info;
    this.stepFields = fields_data
      ? this.getFormFieldsModels(fields_data, userProfileDetails, product)
      : [];
  }

  getFormFieldsModels = (
    fieldsData: FormFieldsType[],
    userProfileDetails: UserProfileModel | null,
    product?: AllProductTypes | null
  ) => {
    return fieldsData.map((eachField) => {
      return getFieldFromFactory(eachField, userProfileDetails, product);
    });
  };
}
export default StepConfig;
